"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../../styles");
var Data = require("../../data");
var Difficulty = /** @class */ (function (_super) {
    __extends(Difficulty, _super);
    function Difficulty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Difficulty.prototype.render = function () {
        var difficultyOptions = [];
        Data.difficulties.forEach(function (optionData, index) {
            var text = optionData.name + " (" + optionData.rows + "x" +
                (optionData.cols + " - " + optionData.mines + " mines)");
            difficultyOptions.push(React.createElement("option", { key: index, value: index }, text));
        });
        return (React.createElement("p", { key: 'difficulty' },
            "Difficulty:",
            React.createElement("select", { id: 'difficulty', style: Styles.difficultySelect, value: this.props.value, onChange: this.props.onChange }, difficultyOptions)));
    };
    return Difficulty;
}(React.Component));
exports.Difficulty = Difficulty;
//# sourceMappingURL=Difficulty.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Setup/Difficulty.js
// module id = 29
// module chunks = 0